import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Segment } from 'semantic-ui-react'
import CartHeader from './CartHeader'
import CustomerCart from './CustomerCart'
import Fragment from 'react-dot-fragment'

const mapStateToProps = (state, ownProps) => {
  const { customerOrders = {} } = state.carts
  const { users = [] } = state.userAdmin
  const {
    match: {
      params: { cart_id },
    },
  } = ownProps
  return { customerOrders, users, cart_id: Number(cart_id) }
}

const mapDispatchToProps = undefined

class CustomerCartDetails extends React.Component {
  printCart = () => window.print()

  actions() {
    return [
      {
        icon: 'print',
        color: 'grey',
        content: I18n.t('admin.carts.details.print'),
        onClick: (event) => {
          event.preventDefault()
          this.printCart()
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    // props
    const { customerOrders, cart_id } = this.props

    const cart =
      (customerOrders.carts || []).find((cart) => cart.id === cart_id) || {}
    const { data = {} } = cart

    if (!cart.id) return <ComponentPlaceholder inactive loading={false} />
    console.log(cart)

    return (
      <div className={classNames(['cartDetails', dark && 'inverted'])}>
        <ComponentHeader
          title={I18n.t(`admin.carts.details.title_customer_order`, {
            customerName: cart.data.billing_address.address_1,
            cartDate: new Date(cart.created_at).toLocaleDateString(
              'de-CH',
              config.format.date
            ),
          })}
          actions={this.actions()}
        />

        <Segment attached className={classNames([dark && 'inverted'])}>
          <CartHeader {...data} />
        </Segment>

        {(cart.data || {}).dealer_id > 1 && (
          <Fragment>
            <ComponentHeader title="BOP-Rechnung" />
            <Segment
              attached
              className={classNames(['payload', dark && 'inverted'])}>
              <CustomerCart cart={cart} dealerVersion />
            </Segment>
          </Fragment>
        )}
        <ComponentHeader title="Endkunden-Rechnung" />
        <Segment
          attached
          className={classNames(['payload', dark && 'inverted'])}>
          <CustomerCart cart={cart} />
        </Segment>
      </div>
    )
  }
}

CustomerCartDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerCartDetails)
export default withRouter(CustomerCartDetails)



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CustomerCart/CustomerCartDetails.jsx